import { useEffect, useRef, useState } from 'react';
import BenzAMRRecorder from 'benz-amr-recorder';

export const useAmrPlay = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    const armRef = useRef<BenzAMRRecorder>();

    const playAmrAudio = async (url: string) => {
        if (isPlaying) {
            armRef.current?.stop();
        } else {
            armRef.current = new BenzAMRRecorder();

            armRef.current?.initWithUrl(url).then(() => {
                setIsPlaying(true);
                armRef.current?.play();
            });

            armRef.current.onEnded(() => {
                setIsPlaying(false);
                console.log('播放完毕');
            });

            armRef.current.onStop(() => {
                setIsPlaying(false);
                console.log('播放停止');
            });
        }
    };

    useEffect(() => {
        return () => {
            armRef.current?.destroy();
            armRef.current = undefined;
        };
    }, []);

    return {
        playAmrAudio,
        isPlaying,
    };
};
